"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const button_1 = require("@kyruus/button");
const intl_1 = require("@kyruus/intl");
const react_1 = __importDefault(require("react"));
const messages_1 = __importDefault(require("../../lib/messages"));
const react_2 = require("@xstate/react");
const Tracking_1 = require("../../lib/constants/Tracking");
const styles_1 = require("./styles");
const useManageAppointmentContext_1 = require("../../../ManageAppointment/hooks/useManageAppointmentContext");
const SearchProviderButton = ({ service }) => {
    const [state] = (0, react_2.useService)(service);
    const { context } = state;
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const handleNewSearchButtonClick = () => {
        track(Tracking_1.userEvents.CLICK_NEW_SEARCH_CTA);
    };
    return (react_1.default.createElement("section", { "data-testid": "search-provider-section" },
        react_1.default.createElement(styles_1.StyledHeading, { "data-testid": "search-provider-heading" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.newSearchHeading))),
        react_1.default.createElement(button_1.ButtonLink, { href: context === null || context === void 0 ? void 0 : context.searchProvidersLink, mode: "ghost", onClick: handleNewSearchButtonClick, "data-testid": "search-provider-button" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.newSearchLinkText)))));
};
exports.default = SearchProviderButton;
//# sourceMappingURL=SearchProviderButton.js.map